import React from 'react';
import { Box, Button, Loader, Text, TextButton } from '@wix/design-system';
import { StyledText } from '../TextTyper/StyledText';
import s from './ConsentModal.module.scss';
import ReactMarkdown from 'react-markdown';
import { CONSENT_STATUS, useConsent } from '../../hooks/useConsent';
import { ChatMessageData } from '../../types';
import cs from 'classnames';

const StatusBox: React.FC<{ status: CONSENT_STATUS }> = ({ status }) => {
  const statusColorClassName = cs(s.statusColor, {
    [s.defaultState]: status === CONSENT_STATUS.NOT_SELECTED,
    [s.approved]: status === CONSENT_STATUS.APPROVED,
    [s.denied]: status === CONSENT_STATUS.DENIED,
  });

  const statusText = {
    [CONSENT_STATUS.NOT_SELECTED]: 'Confirmation required:',
    [CONSENT_STATUS.APPROVED]: 'Approved',
    [CONSENT_STATUS.DENIED]: 'Denied',
  };

  return (
    <Box direction="horizontal" className={s.statusBoxContainer}>
      <Box direction="horizontal" gap="SP2" className={s.statusBox}>
        <Box className={statusColorClassName} />
        <Box className={s.statusText}>
          <StyledText>
            <Text size="small">{statusText[status]}</Text>
          </StyledText>
        </Box>
      </Box>
      {status !== CONSENT_STATUS.NOT_SELECTED && (
        <Box className={s.loader}>
          <Loader size="tiny" />
        </Box>
      )}
    </Box>
  );
};
export type ConsentModalProps = {
  chatMessages: ChatMessageData[];
};
export const ConsentModal: React.FC<ConsentModalProps> = ({ chatMessages }) => {
  const {
    showConsent,
    consentData,
    consentMessage,
    consentStatus,
    setConsentStatus,
  } = useConsent(chatMessages);
  const userSelected = consentStatus !== CONSENT_STATUS.NOT_SELECTED;
  return (
    <Box className={cs(s.root, { [s.visible]: showConsent })}>
      <Box className={s.consentOverlay} />
      <Box className={s.consentWrapper}>
        <Box direction="vertical" className={s.container} gap="SP2">
          <StatusBox status={consentStatus} />
          <Box direction="vertical" gap="SP2" className={s.body}>
            <StyledText>
              <Text className={s.content} size="tiny">
                <ReactMarkdown>
                  {consentData?.text || '**Action:** Are you sure?'}
                </ReactMarkdown>
              </Text>
            </StyledText>
            {!userSelected && (
              <Box direction="horizontal" align="right">
                <Box marginRight="SP1" gap="SP2">
                  <TextButton
                    size="tiny"
                    onClick={() => {
                      setConsentStatus(CONSENT_STATUS.DENIED);
                      consentMessage.handler(false);
                    }}
                    className={s.deny}
                  >
                    {consentData?.denyText || 'Deny'}
                  </TextButton>
                  <Button
                    onClick={() => {
                      setConsentStatus(CONSENT_STATUS.APPROVED);
                      consentMessage.handler(true);
                    }}
                    size="tiny"
                  >
                    {consentData?.approveText || 'Accept'}
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
